import { useMemo, useState } from "react";

const matchesFilters = (order, { searchText, dueDateFrom, dueDateTo, branchFilter }) => {
  if (searchText) {
    const needle = searchText.trim().toLowerCase();
    const haystack = `${order.ORDNAME || ""} ${order.CDES || ""}`.toLowerCase();
    if (!haystack.includes(needle)) return false;
  }
  if (order.NEO_DUEDATE) {
    const dueDate = new Date(order.NEO_DUEDATE);
    if (dueDateFrom && dueDate < new Date(dueDateFrom)) return false;
    if (dueDateTo && dueDate > new Date(dueDateTo)) return false;
  } else if (dueDateFrom || dueDateTo) {
    return false;
  }
  return branchFilter.length === 0 || branchFilter.includes(order.BRANCHNAME);
};

// Filters of the orders tab. initialSearch pre-filters to an order opened from an email link.
const useOrdersFilter = (orders, initialSearch = "") => {
  const [searchText, setSearchText] = useState(initialSearch);
  const [dueDateFrom, setDueDateFrom] = useState("");
  const [dueDateTo, setDueDateTo] = useState("");
  const [branchFilter, setBranchFilter] = useState([]);

  // Only branches present in the loaded orders — no point offering empty ones.
  const availableBranches = useMemo(
    () => [...new Set(orders.map((o) => o.BRANCHNAME).filter(Boolean))].sort(),
    [orders],
  );
  const filteredOrders = useMemo(
    () => orders.filter((o) => matchesFilters(o, { searchText, dueDateFrom, dueDateTo, branchFilter })),
    [orders, searchText, dueDateFrom, dueDateTo, branchFilter],
  );
  const hasActiveFilters = !!searchText || !!dueDateFrom || !!dueDateTo || branchFilter.length > 0;

  const clearFilters = () => {
    setSearchText("");
    setDueDateFrom("");
    setDueDateTo("");
    setBranchFilter([]);
  };

  return {
    values: { searchText, dueDateFrom, dueDateTo, branchFilter },
    setters: { setSearchText, setDueDateFrom, setDueDateTo, setBranchFilter },
    availableBranches,
    filteredOrders,
    hasActiveFilters,
    clearFilters,
  };
};

export default useOrdersFilter;
